<template>
  <div></div>
</template>

<script></script>
<style lang="sass">

    @import ../../common/styles/settings
    @import ../../common/styles/mixins

</style>


